import React, { useCallback, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import HomeIcon from '@material-ui/icons/Home';
import Grid from '@toast-ui/react-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';


function PurchaseListSerche() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료

  const gridRef = useRef();

  const [purchaseList, setPurchaseList] = useState([]);
  const [purSelextData, sertPurSelextData] = useState([]);
  const [supplier, setSupplier] = useState(''); //업체명
  const [saupjaNo, setSaupjaNo] = useState(''); //업체사업자번호
  const [upchejuso, setUpchejuso] = useState(''); //업체주소
  const [upcheYesNo, setUpcheYesNo] = useState('Yes'); //업체사용유무
  const [purchaseNameChange, setPurchaseNameChange] = useState('');

  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    if (pwloading !== urlpw) {
      //window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login/');
    }
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료

  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        sertPurSelextData(res.data);
      })
  }, [])

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const purchaseAPI = useCallback(() => {
    const url = '/api/PurchaseList/';
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: { purchaseName: purchaseNameChange } }),
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          // setMsg('정상적으로 저장되었습니다.');
          // console.log(res.data);
        }),
      update: (id, updatedRecord) => axios.put(url + id, updatedRecord).then((res) => {
        alert('정상적으로 수정되었습니다.');
      }).catch(error => {
        alert("수정이 안되고 있습니다[중복확인하시길 바랍니다].")
        // console.log(error);
      }),
    };
  }, [headers, purchaseNameChange]);


  const refreshPurchaseList = useCallback(async () => {
    await purchaseAPI()
      .fetchAll()
      .then((res) => {
        setPurchaseList(res.data);
      })
      .catch((err) => console.log(err));
  }, [purchaseAPI]);

  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      {
        name: "edit", header: "수정", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
          //return '<button type="button" class="btn btn-outline-primary btn-sm">수정</button>';
        }
      },
      // { name: "Id", header: "Id", align: "left", width: 50 }, //숨김처리
      { name: "s_업체코드", header: "코드", align: "left", width: 60 },
      { name: "s_업체상호", header: "업체상호", align: "left", width: 150 },
      { name: "s_업체사업자번호", header: "사업자번호", align: "center", width: 110 },
      { name: "s_업체업종", header: "업체업종", align: "center", width: 140 },
      { name: "s_대표자성명", header: "대표자성명", align: "center", width: 90 },
      { name: "s_대표자전화", header: "대표메일", align: "center", width: 100 },
      { name: "s_업체전화", header: "업체전화", align: "center", width: 110 },
      { name: "s_업체팩스", header: "업체팩스", align: "center", width: 100 },
      { name: "s_업체관리자전화", header: "담당자전화", align: "center", width: 100 },
      { name: "s_업체관리자성명", header: "담당자성명", align: "center", width: 80 },
      { name: "s_업체주소", header: "업체주소", align: "left", width: 329 },
      { name: "s_업무구분", header: "자재구분", align: "center", width: 70 },
      { name: "s_업체자재불출유무", header: "Osp유무", align: "center", width: 70 },
      { name: "s_등록일자", header: "등록일자", align: "center", width: 130 },
      { name: "s_등록자", header: "등록자", align: "center", width: 80 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = purchaseList.map((row, index) => ({
    //id: row.id,
    No: index + 1,
    edit: '수정',
    Id: row.id,
    s_업체코드: row.s_업체코드,
    s_업체상호: row.s_업체상호,
    s_업체사업자번호: row.s_업체사업자번호,
    s_업체업종: row.s_업체업종,
    s_대표자성명: row.s_대표자성명,
    s_대표자전화: row.s_대표자전화,
    s_업체전화: row.s_업체전화,
    s_업체팩스: row.s_업체팩스,
    s_업체관리자전화: row.s_업체관리자전화,
    s_업체관리자성명: row.s_업체관리자성명,
    s_업체주소: row.s_업체주소,
    s_업무구분: row.s_업무구분,
    s_업체자재불출유무: row.s_업체자재불출유무,
    s_등록일자: row.s_등록일자,
    s_등록자: row.s_등록자,
    delete: '삭제'
  }));

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: 'pink',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = purSelextData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );

  const haneleSuppilerOnClick = ((e) => {
    //setPurchaseNameChange('')
  })

  const haneleSuppilerCodeOnChange = ((e) => {
    e.preventDefault()
    setSaupjaNo(e.target.value)
  })
  const haneleSuppilerCodeOnClick = ((e) => {
    //setPurchaseNameChange('')
  })

  const haneleSuppilerJusoOnChange = ((e) => {
    e.preventDefault()
    setUpchejuso(e.target.value)
  })
  const haneleSuppilerJusoOnClick = ((e) => {
    //setPurchaseNameChange('')
  })

   //구매업체사용유무
   const haneleSuppilerYesNoOnChange = ((e) => {
    e.preventDefault()
    setUpcheYesNo(e.target.value)
    console.log(upcheYesNo);
  })

  //검색클릭 값변경
  const handleInputPurchaseNameChange = (e) => {
    e.preventDefault();
    setPurchaseNameChange(e.target.value);
  };

  //검색클릭
  const handleInputPurchaseNameEnter = (e) => {
    e.preventDefault();
    if (purchaseNameChange !== '' && e.key === 'Enter') {
      refreshPurchaseList(); // null이 아니면 실행됨
    }
    else {
      setPurchaseList([]);
    }
  };

  //조회 버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      s_업체코드: supplier.value ? supplier.value : null,   //업체코드
      s_업체사업자번호: evValue.get("saupjaNo") ? evValue.get("saupjaNo") : null,
      s_업체주소: evValue.get("upchejuso") ? evValue.get("upchejuso") : null,
      s_사용유무: upcheYesNo ? upcheYesNo : null,
    }
    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/PurchaseList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, {
      params: {
        purchaseCode: DataSerche.s_업체코드,
        purchaseSaupjaNo: DataSerche.s_업체사업자번호,
        purchaseUpchejuso: DataSerche.s_업체주소,
        purchaseUpcheYesNo: DataSerche.s_사용유무
      }
    })
      .then((res) => {
        setPurchaseList(res.data);
      })
  };

  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매업체조회</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12" >
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ""}
                size="small"
                style={{ width: 200, marginRight: 3 }}
                value={supplier ? supplier : setSupplier('%')}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="사업자번호"
                name="saupjaNo"
                value={saupjaNo}
                // autoComplete={saupjaNo}
                onChange={haneleSuppilerCodeOnChange}
                onClick={haneleSuppilerCodeOnClick}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="업체주소"
                name="upchejuso"
                value={upchejuso}
                // autoComplete={upchejuso}
                onChange={haneleSuppilerJusoOnChange}
                onClick={haneleSuppilerJusoOnClick}
              />
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 110,
                  marginRight: 10,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 110,
                  float: "center",
                }}
                onClick={() => {
                  window.location.href = "/home/index";
                }}
              >
                홈이동
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="purchaseNameChange"
          value={purchaseNameChange}
          onChange={handleInputPurchaseNameChange}
          onKeyUp={handleInputPurchaseNameEnter}
          // onClick={() => {
          //   setPurchaseNameChange('');
          //   setSupplier('')
          //   setSaupjaNo('')
          //   setUpchejuso('')
          // }}
        />
      </div>
      <Container maxWidth="xl">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={29}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50,
              resizable: true,
            }}
            ref={gridRef}
          // onClick={handleEditClick}
          />
        </Box>
      </Container>
    </>
  )
}

export default PurchaseListSerche;
